<template>
  <nav class="results-pagination container--large" aria-label="pagination">
    <ul class="results-pagination__list" aria-label="pagination">
      <li class="results-pagination__list-item results-pagination__list-item--first" v-if="currentPage > 1"  @click.prevent="updateCurrentPage(1)">
        <a href=".">First</a>
      </li>
      <li class="results-pagination__list-item results-pagination__list-item--previous" v-if="currentPage > 1" @click.prevent="updateCurrentPage(currentPage-1)">
        <a href=".">Previous</a>
      </li>
      <li class="results-pagination__list-item" v-if="currentPage - 2 > 0" @click.prevent="updateCurrentPage(currentPage-2)">
        <a href=".">{{ currentPage - 2 }}</a>
      </li>
      <li class="results-pagination__list-item" v-if="currentPage - 1 > 0" @click.prevent="updateCurrentPage(currentPage-1)">
        <a href=".">{{ currentPage - 1}}</a>
      </li>
      <li class="results-pagination__list-item is-active">{{ currentPage }}</li>
      <li class="results-pagination__list-item" v-if="currentPage + 1 <= resultsData.totalPages" @click.prevent="updateCurrentPage(currentPage+1)">
        <a href=".">{{ currentPage + 1 }}</a>
      </li>
      <li class="results-pagination__list-item" v-if="currentPage + 2 <= resultsData.totalPages" @click.prevent="updateCurrentPage(currentPage+2)">
        <a href=".">{{ currentPage + 2 }}</a>
      </li>
      <li class="results-pagination__list-item results-pagination__list-item--next" v-if="resultsData.totalPages > 1 && this.currentPage < resultsData.totalPages" @click.prevent="updateCurrentPage(currentPage+1)">
        <a href=".">Next</a>
      </li>
      <li class="results-pagination__list-item results-pagination__list-item--last" v-if="resultsData.totalPages > 1 && this.currentPage < resultsData.totalPages" @click.prevent="updateCurrentPage(resultsData.totalPages)">
        <a href=".">Last</a>
      </li>
    </ul>
  </nav>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    name: 'ResultsPagination',
    computed: {
      ...mapGetters({
        currentPage: 'getCurrentPage',
        resultsData: 'getResultsData',
      })
    },
    methods: {
      updateCurrentPage(currentPage) {
        this.$store.commit('updateCurrentPage', currentPage)
        this.$emit('update')
        this.scrollToTop()
      },
      scrollToTop() {
        document.getElementById("results-meta").scrollIntoView();
      }
    }
  }

</script>
